import TheContainer from '@/containers/TheContainer'

export default [
  // Admin Global Scope
  {
    path: '/admin/email-schedules',
    name: 'admin.emailSchedules',
    component: TheContainer,
    meta: {
      scopeType: 'global',
      breadcrumb: {
        to: { name: 'admin.emailSchedules.list' },
        text: 'Email Schedules'
      }
    },
    children: [
      {
        path: 'list',
        name: 'admin.emailSchedules.list',
        component: () => import('./ListEmailSchedules.vue'),
        meta: {
          scopeType: 'global',
          permission: 'admin.email_scheduler.list',
          label: 'Email Schedules'
        }
      },
      {
        path: 'new',
        name: 'admin.emailSchedules.new',
        component: () => import('./NewEmailSchedule.vue'),
        meta: {
          scopeType: 'global',
          permission: 'admin.email_scheduler.create',
          label: 'Create Email Schedule',
          breadcrumb: { text: 'Create New' }
        }
      },
      {
        path: ':scheduleId',
        name: 'admin.emailSchedules.edit',
        component: () => import('./EditEmailSchedule.vue'),
        meta: {
          scopeType: 'global',
          permission: 'admin.email_scheduler.edit',
          label: 'Edit Email Schedule',
          breadcrumb: {
            text: (context) => {
              const schedule = context.store.getters['emailSchedules/schedule']
              return schedule ? schedule.job_type : 'Edit'
            }
          }
        }
      }
    ]
  },

  // Contract Manager Scope
  {
    path: '/contract-manager/:contractManagerId/email-schedules',
    name: 'contractManager.emailSchedules',
    component: TheContainer,
    meta: {
      scopeType: 'contract-manager',
      breadcrumb: (context) => {
        const cm = context.store.getters['contractManager/contract_manager']
        const contractManagerId = context.route.params.contractManagerId

        // Trigger fetch if not loaded
        if (!cm || cm.id !== parseInt(contractManagerId)) {
          context.store.dispatch('contractManager/fetchContractManager', contractManagerId)
            .catch(err => console.error('Failed to load contract manager for breadcrumb:', err))
        }

        return [
          { to: { name: 'index' }, text: context.gettext('Dashboard') },
          { to: { name: 'contract_manager.list' }, text: 'Contract Managers' },
          {
            to: { name: 'contract_manager.detail', params: { id: contractManagerId } },
            text: cm && cm.id === parseInt(contractManagerId) ? cm.name : `Contract Manager #${contractManagerId}`
          }
        ]
      },
      breadcrumbMode: 'replace'
    },
    children: [
      {
        path: 'list',
        name: 'contractManager.emailSchedules.list',
        component: () => import('./ListEmailSchedules.vue'),
        meta: {
          scopeType: 'contract-manager',
          permission: 'contract_manager.email_scheduler.list',
          label: 'Email Schedules'
        }
      },
      {
        path: 'new',
        name: 'contractManager.emailSchedules.new',
        component: () => import('./NewEmailSchedule.vue'),
        meta: {
          scopeType: 'contract-manager',
          permission: 'contract_manager.email_scheduler.create',
          label: 'Create Email Schedule',
          breadcrumb: { text: 'Create New' }
        }
      },
      {
        path: ':scheduleId',
        name: 'contractManager.emailSchedules.edit',
        component: () => import('./EditEmailSchedule.vue'),
        meta: {
          scopeType: 'contract-manager',
          permission: 'contract_manager.email_scheduler.edit',
          label: 'Edit Email Schedule',
          breadcrumb: {
            text: (context) => {
              const schedule = context.store.getters['emailSchedules/schedule']
              return schedule ? schedule.job_type : 'Edit'
            }
          }
        }
      }
    ]
  },

  // Event Owner Scope
  {
    path: '/event-owner/:eventOwnerId/email-schedules',
    name: 'eventOwner.emailSchedules',
    component: TheContainer,
    meta: {
      scopeType: 'event-owner',
      breadcrumb: (context) => {
        const eo = context.store.getters['eventOwner/event_owner']
        const eventOwnerId = context.route.params.eventOwnerId

        // Trigger fetch if not loaded
        if (!eo || eo.id !== parseInt(eventOwnerId)) {
          context.store.dispatch('eventOwner/fetchEventOwner', eventOwnerId)
            .catch(err => console.error('Failed to load event owner for breadcrumb:', err))
        }

        return [
          { to: { name: 'index' }, text: context.gettext('Dashboard') },
          { to: { name: 'event_owner.list' }, text: 'Event Owners' },
          {
            to: { name: 'event_owner.detail', params: { id: eventOwnerId } },
            text: eo && eo.id === parseInt(eventOwnerId) ? eo.company_name : `Event Owner #${eventOwnerId}`
          }
        ]
      },
      breadcrumbMode: 'replace'
    },
    children: [
      {
        path: 'list',
        name: 'eventOwner.emailSchedules.list',
        component: () => import('./ListEmailSchedules.vue'),
        meta: {
          scopeType: 'event-owner',
          permission: 'event_owner.email_scheduler.list',
          label: 'Email Schedules'
        }
      },
      {
        path: 'new',
        name: 'eventOwner.emailSchedules.new',
        component: () => import('./NewEmailSchedule.vue'),
        meta: {
          scopeType: 'event-owner',
          permission: 'event_owner.email_scheduler.create',
          label: 'Create Email Schedule',
          breadcrumb: { text: 'Create New' }
        }
      },
      {
        path: ':scheduleId',
        name: 'eventOwner.emailSchedules.edit',
        component: () => import('./EditEmailSchedule.vue'),
        meta: {
          scopeType: 'event-owner',
          permission: 'event_owner.email_scheduler.edit',
          label: 'Edit Email Schedule',
          breadcrumb: {
            text: (context) => {
              const schedule = context.store.getters['emailSchedules/schedule']
              return schedule ? schedule.job_type : 'Edit'
            }
          }
        }
      }
    ]
  }
]
